import React from 'react';
import { motion } from 'framer-motion';
import { LayoutDashboard, Building2, Briefcase } from 'lucide-react';

const Services = () => {
  const services = [
    {
      title: "Turnkey Solutions",
      description: "Complete interior solutions from design to execution, ensuring seamless project delivery with quality assurance.",
      icon: <LayoutDashboard size={48} strokeWidth={1.5} />
    },
    {
      title: "Residential Interiors",
      description: "Luxurious and functional designs for bungalows and apartments tailored to your lifestyle and preferences.",
      icon: <Building2 size={48} strokeWidth={1.5} />
    },
    {
      title: "Commercial & Offices",
      description: "Professional and inspiring workspaces designed to enhance productivity and reflect your brand identity.",
      icon: <Briefcase size={48} strokeWidth={1.5} />
    }
  ];

  return (
    <section
      id="services"
      className="py-20 relative overflow-hidden"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Light overlay to make white cards stand out */}
      <div className="absolute inset-0 bg-black/40"></div>

      <div className="relative z-10 container mx-auto px-4">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4"
          >
            Our <span className="text-yellow-400">Services</span>
          </motion.h2>
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: 100 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="h-1 bg-gradient-to-r from-yellow-400 to-yellow-600 w-24 mx-auto mb-6"
          />
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-lg sm:text-xl text-gray-200 max-w-3xl mx-auto px-4"
          >
            Comprehensive interior solutions designed to meet the unique needs of residential, commercial, and builder projects.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative overflow-hidden rounded-xl border border-gray-200 bg-white/90 backdrop-blur-sm transition-all duration-500 hover:shadow-2xl hover:-translate-y-2 h-full"
              style={{
                border: '1px solid rgba(220, 220, 220, 0.8)',
              }}
            >
              <div className="p-8 h-full flex flex-col items-center text-center">
                <div className="mb-6 text-yellow-600">
                  {service.icon}
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  {service.description}
                </p>
              </div>

              {/* Gold border effect on hover */}
              <div className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                style={{
                  border: '2px solid rgba(255, 215, 0, 0.8)',
                }}
              ></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;